export default __webpack_public_path__ + "static/media/Industrial Vision Systems.f122129a.png";